import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { IrisIconButtonModule } from '@sondermind/iris/icon-button';
import { NativeAppInterfaceModule } from '@sondermind/native-app-interface';

import { SonderModalComponent } from './sonder-modal.component';

@NgModule({
  imports: [
    A11yModule,
    CommonModule,
    IrisIconButtonModule,
    MatIconModule,
    MatButtonModule,
    NativeAppInterfaceModule
  ],
  declarations: [
    SonderModalComponent,
  ],
  exports: [
    SonderModalComponent,
  ]
})

export class SonderModalModule {}
